import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesParceiros {
  ler: boolean;
  criar: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `parceiros`
 * (`apps/api/src/modules/parceiros/parceiros.routes.ts`, seed original
 * da migration `004`): `admin` (curinga `*`) e o papel interno
 * `parceiros` (equipe responsável pelo programa de afiliados, distinto
 * do perfil externo "Parceiro" de portal — `docs/architecture/005-modulo-auth.md`)
 * têm `ler`/`criar`/`atualizar`/`excluir`. Nenhum outro papel tem
 * qualquer permissão sobre este recurso. Usado apenas para decidir o
 * que mostrar na UI — a autorização real é sempre revalidada pelo
 * backend.
 */
export function permissoesParceiros(papel: PapelUsuario): PermissoesParceiros {
  if (papel === 'admin' || papel === 'parceiros') {
    return { ler: true, criar: true, atualizar: true };
  }
  return { ler: false, criar: false, atualizar: false };
}
